import GenericSelect from "./GenericSelect";
import useCompanyForm from "../hooks/useCompanyForm";

type Props = {
  onChange: (companyId, company) => void;
  value: any;
  className?: string;
  error?: boolean;
  multiple?: boolean;
  required?: boolean;
  disabled?: boolean;
  label?: string;
  placeholder?: string;
};

function SectorSelect({
  disabled: _disabled,
  className,
  label = "Secteur",
  placeholder = "Sélectionnez un secteur",
  value,
  ...props
}: Props) {
  const { sectors } = useCompanyForm();

  return (
    <GenericSelect
      value={value}
      valueKey="value"
      className={className}
      label={label}
      placeholder={placeholder}
      options={sectors || []}
      {...props}
    />
  );
}
export default SectorSelect;
